import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RejectModalDataType, SystemMessageResponseType } from './types';
import { CustomInput, DropDown, ToggleButton } from '../../../components/common';
import Modal from '../../../components/common/modal';
import { SystemMessage, useSystemMessages } from '../../../hooks/useComms';

interface RejectMessageModalProps {
  messagePopup: boolean;
  handleModalCancel: () => void;
  handleModalSave: (rejectModalData: RejectModalDataType) => void;
}

const RejectMessageModal: React.FunctionComponent<RejectMessageModalProps> = ({
  messagePopup,
  handleModalCancel,
  handleModalSave,
}): JSX.Element => {
  const { data: systemMessages } = useSystemMessages();
  const displayNameRejectedMessages = systemMessages?.filter(
    (item: SystemMessage) => item.group?.key === 'display_name_rejected',
  );
  const [rejectModalData, setRejectModalData] = useState<RejectModalDataType>();

  if (!rejectModalData && displayNameRejectedMessages) {
    setRejectModalData({
      send_message: true,
      system_message_id: displayNameRejectedMessages?.[0]?.id,
      subject: displayNameRejectedMessages?.[0]?.subject,
      message: displayNameRejectedMessages?.[0]?.message,
    });
  }

  return (
    <Modal
      isModel={messagePopup}
      InnerComponent={
        <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-xl sm:align-middle">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="flow-root">
              <div className="float-left w-48 sm:ml-4 sm:text-left">
                <div className="flex items-center justify-between">
                  <label className="text-blue-dark mb-2 block text-sm leading-4"> Send Message </label>

                  <ToggleButton
                    data-testid="send-message-toggle"
                    id={'Send Message'}
                    status={rejectModalData?.send_message}
                    setStatus={(data) => {
                      setRejectModalData((prev: any) => ({
                        ...prev,

                        send_message: data,
                      }));
                    }}
                    initialstatus={true}
                  ></ToggleButton>
                </div>
              </div>
              <div className="float-right w-80">
                <DropDown
                  data-testid="reject-message-dropdown"
                  Label=""
                  value={rejectModalData?.system_message_id || systemMessages?.[0]?.id}
                  setValue={(data) => {
                    const selectedMessage = displayNameRejectedMessages?.find(
                      (item: SystemMessageResponseType) => item.id === Number(data),
                    );
                    setRejectModalData((prev: any) => {
                      if (!selectedMessage) {
                        return prev;
                      }
                      return {
                        ...prev,
                        system_message_id: selectedMessage.id,
                        subject: selectedMessage.subject,
                        message: selectedMessage.message,
                      };
                    });
                  }}
                >
                  {displayNameRejectedMessages?.map((item: SystemMessage) => (
                    <option key={item.name} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </DropDown>
              </div>
            </div>
            <div className="sm:flex sm:items-start">
              <div className="mt-3 w-full text-center sm:ml-4 sm:mt-0 sm:text-left">
                <div className="my-2 w-full">
                  <CustomInput
                    inputType={'text'}
                    value={rejectModalData?.subject}
                    setValue={(data) => {
                      setRejectModalData((prev: any) => ({
                        ...prev,

                        subject: data,
                      }));
                    }}
                    Label={'Subject'}
                    labelClass={'block text-sm leading-4 text-blue-dark mb-2'}
                    dataTestId="reject-message-subject"
                  />
                </div>

                <h3 className="text-blue-dark mb-2 block text-sm leading-4" id="modal-title">
                  Body
                </h3>

                <div className="my-2 w-full">
                  <textarea
                    className="text-gray-dark bg-gray-background-light h-28 w-full rounded-md px-3 py-2 text-sm font-extrabold leading-4 focus:outline-none"
                    value={rejectModalData?.message}
                    onChange={(evt) => {
                      setRejectModalData((prev: any) => ({
                        ...prev,

                        message: evt.target.value,
                      }));
                    }}
                    data-testid="reject-message-modal-body"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <button
              data-testid="reject-and-send-message"
              type="button"
              onClick={() => rejectModalData && handleModalSave(rejectModalData)}
              className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
            >
              {rejectModalData?.send_message ? 'REJECT AND SEND MESSAGE' : 'REJECT DISPLAY NAME'}
            </button>

            <button
              data-testid="close-reject-message-modal"
              type="button"
              onClick={handleModalCancel}
              className="stacked-bar-blue-400 inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
            >
              CLOSE
            </button>
          </div>
        </div>
      }
    />
  );
};

export default RejectMessageModal;
